import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { WhatIsSection } from './components/WhatIsSection';
import { WhatWeWorkSection } from './components/WhatWeWorkSection';
import { WhatIncludesSection } from './components/WhatIncludesSection';
import { IsForYouSection } from './components/IsForYouSection';
import { OutcomesSection } from './components/OutcomesSection';
import { AboutCarelizSection } from './components/AboutCarelizSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
import { WhatsAppFloat } from './components/WhatsAppFloat';
export function App() {
  return <div className="min-h-screen bg-brand-brown selection:bg-brand-gold/30 selection:text-brand-cream" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <WhatIsSection data-id="element-4" />
        <WhatWeWorkSection data-id="element-5" />
        <WhatIncludesSection data-id="element-6" />
        <IsForYouSection data-id="element-7" />
        <OutcomesSection data-id="element-8" />
        <AboutCarelizSection data-id="element-9" />
        <PricingSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
      <WhatsAppFloat data-id="element-12" />
    </div>;
}